import React from 'react';
import {ModalInfo} from '../'

export const ErrorHandler = ({ status, error }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [textsucces, setTextsucces] = React.useState('');
  const [iconVisual, setIconVisual] = React.useState(false);

  React.useEffect(() => {
    if (status === 'rejected' && error) {
      setShowModal(true);
      setIconVisual(false);
      setTextsucces(error || "Неизвестная ошибка, попробуйте позже");
    }
  }, [status, error]);

  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <>
    { showModal &&
      <ModalInfo 
      isOpen={showModal} 
      textError={textsucces} 
      onClose={handleModalClose} 
      icon={iconVisual} 
      name="modal-info" 
    />
    }
   </>
  );
};


/*export const ErrorHandler = (status, error) => {
  const [showModal, setShowModal] = React.useState(false) // Показывает информацию(ошибки или успешные действия с сервером)
  const [textsucces, setTextsucces] = React.useState(''); // Текст для ошибки 
  const [iconVisual,setIconVisual] = React.useState(false); //Иконка для ошибки
  console.log(status, error)
 
  React.useEffect(() => {
    if (status === 'rejected' && error) {
      setShowModal(true);
      setIconVisual(false);
      setTextsucces(error || "Неизвестная ошибка, попробуйте позже"); 
    }
}, [status, error]);
 
function handleModalClose() {
    setShowModal(false)
  }

return (
    <ModalInfo isOpen={showModal} textError={textsucces} onClose={handleModalClose} icon={iconVisual} name="modal-info" />
)
}*/